import { applyPortalMetaTags, ORGANIZATION_DISPLAY_NAME, SUPPORT_EMAIL } from '../config/branding';

const MAX_META = 320;

function clipMeta(s) {
  const t = String(s || '').trim();
  if (!t) return '';
  if (t.length <= MAX_META) return t;
  return `${t.slice(0, MAX_META - 1)}…`;
}

function projectPortal(settings) {
  const pp = settings?.project_portal;
  return pp && typeof pp === 'object' ? pp : {};
}

/**
 * E-mail support : console projet (`project_portal.support_email`) → fiche projet → .env.
 */
export function getResolvedSupportEmail(settings) {
  const pp = projectPortal(settings);
  const fromProject = String(pp.support_email || '').trim();
  if (fromProject) return fromProject;
  const o = settings?.organization || {};
  const dedicated = String(o.support_email || '').trim();
  if (dedicated) return dedicated;
  const contact = String(o.email || '').trim();
  if (contact) return contact;
  return SUPPORT_EMAIL;
}

/**
 * Nom affiché : fiche Entrea (`organization.name`) → nom projet console (`project_portal.name`) → .env.
 */
export function getResolvedPortalTitle(settings) {
  const org = settings?.organization || {};
  const pp = projectPortal(settings);
  const n =
    String(org.name || '').trim() ||
    String(pp.name || '').trim();
  return n || ORGANIZATION_DISPLAY_NAME;
}

/**
 * Meta description : `project_portal.site_description` → fiche projet → défaut.
 */
export function getResolvedPortalMetaDescription(settings) {
  const pp = projectPortal(settings);
  const fromProject = String(pp.site_description || '').trim();
  if (fromProject) return clipMeta(fromProject);
  const o = settings?.organization || {};
  const portal = String(o.portal_meta_description || '').trim();
  if (portal) return clipMeta(portal);
  const desc = String(o.description || '').trim();
  if (desc) return clipMeta(desc);
  const title = getResolvedPortalTitle(settings);
  return clipMeta(`${title} — Gestion de l'association`);
}

/** Domaine public affiché (liens, doc) — défini sur le projet dans la console admin. */
export function getResolvedPublicDomain(settings) {
  return String(projectPortal(settings).public_domain || '').trim();
}

/** Met à jour titre d’onglet + meta à partir des paramètres `/settings` (incl. `project_portal`). */
export function syncProjectPortalToDocument(settings) {
  const title = getResolvedPortalTitle(settings);
  const description = getResolvedPortalMetaDescription(settings);
  applyPortalMetaTags({ title, description, ogTitle: title });
}
